import ReactGA from 'react-ga';

const TRACKING_ID = "G-SEEMX17RM2"; // Reemplaza con tu ID de seguimiento
ReactGA.initialize(TRACKING_ID);

export const logPageView = () => {
  ReactGA.pageview(window.location.pathname + window.location.search);
};
